import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  DropdownMenuCheckboxItem,
} from "@/components/ui/dropdown-menu";

import { Settings, MessageSquare, ChevronsDownUp } from "lucide-react";

import { cn } from "@/utils/cn";
import { COLORS } from "@/constants/colors";

import { useTranslation } from "react-i18next";
import { useModal } from "@/contexts/modal";
import { ThemeMenuGroup } from "./ThemeMenuGroup";
import { LanguageMenuGroup } from "./LanguageMenuGroup";
import { useAppStore } from "@/store/useAppStore";

/**
 * Web version of SettingDropdown
 * - No folder selection (server-side config)
 * - No update checking (desktop only)
 */
export const SettingDropdown = () => {
  const { t } = useTranslation("common");
  const { t: tComponents } = useTranslation("components");
  const { openModal } = useModal();
  const { collapseNonUserMessages, setCollapseNonUserMessages } = useAppStore();

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className={cn(
              "p-2 rounded-lg transition-colors cursor-pointer relative",
              COLORS.ui.text.disabled,
              "hover:text-gray-600 hover:bg-gray-100 dark:hover:text-gray-300 dark:hover:bg-gray-800"
            )}
          >
            <Settings className={cn("w-5 h-5", COLORS.ui.text.primary)} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel>{t("settings.title")}</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => openModal("feedback")}>
            <MessageSquare
              className={cn("mr-2 h-4 w-4", COLORS.ui.text.primary)}
            />
            <span>{tComponents("feedback.title")}</span>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuCheckboxItem
            checked={collapseNonUserMessages}
            onCheckedChange={setCollapseNonUserMessages}
          >
            <ChevronsDownUp className={cn("mr-2 h-4 w-4", COLORS.ui.text.primary)} />
            <span>{t("settings.collapseMessages")}</span>
          </DropdownMenuCheckboxItem>
          <DropdownMenuSeparator />
          <ThemeMenuGroup />

          <DropdownMenuSeparator />
          <LanguageMenuGroup />
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
